angular.module('impactx.budget').controller('BudgetDetailCtrl', BudgetDetailCtrl);
BudgetDetailCtrl.$inject = [
    '$scope',
    'dataGen',
    'BackService',
    '$mdToast',
    'ConfirmationService',
    'CommentOnSaveService',
    '$routeParams',
    '$mdDialog',
    'ToolbarService',
    '$redirect',
    'DownloadService'
];

function BudgetDetailCtrl($scope, dataGen, BackService, $mdToast, ConfirmationService, CommentOnSaveService, $routeParams,
                          $mdDialog, ToolbarService, $redirect, DownloadService) {
    var budgetId = $routeParams.id;
    var ctrl = this;

    var getTemplateData = function (btpId) {
        dataGen.getData({}, {id: btpId}, "/budgetTemplate/view").then(function (data) {
            if (data.data) {
                $scope.data.yearBudget.inUse.value = data.data.yearBudget.inUse.value;
                $scope.data.monthBudget.inUse.value = data.data.monthBudget.inUse.value;
                $scope.data.weekBudget.inUse.value = data.data.weekBudget.inUse.value;
                $scope.data.dayBudget.inUse.value = data.data.dayBudget.inUse.value;

                $scope.data.yearBudget.startValue.value = data.data.yearBudget.startValue.value || 0;
                $scope.data.monthBudget.startValue.value = data.data.monthBudget.startValue.value || 0;
                $scope.data.weekBudget.startValue.value = data.data.weekBudget.startValue.value || 0;
                $scope.data.dayBudget.startValue.value = data.data.dayBudget.startValue.value || 0;
                $scope.data.currency.selected = data.data.currency.selected;
                $scope.data.selectedTemplateIsAdditive = data.data.isAdditive && data.data.isAdditive.value;
            }
        });
    };

    $scope.$watch(function () {
            return impactX.isDefined($scope, "data.template.selected.id");
        },
        function (newValue, oldValue) {
            if (newValue && newValue !== oldValue) {
                getTemplateData(newValue);
            }
        }
    );

    this.newTemplate = function (event) {
        showBtdDialog(0, event);
    };

    this.editTemplate = function (event) {
        showBtdDialog($scope.data.template.selected.id, event);
    };

    var showBtdDialog = function (id, event) {
        var isNewBtp = id === 0;
        $mdDialog.show({
            controller: "BudgetTemplateDialogCtrl",
            controllerAs: "budgetTemplateDialogCtrl",
            templateUrl: "modules/budget/templates/btpdialog.tmpl.html",
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: false,
            locals: {
                templateId: id
            }
        }).then(function (data) {
            if (impactX.isDefined(data, "data.id")) {
                $scope.data.template.selected = data.data;
                var entries = $scope.data.template.entries;
                if (isNewBtp) {
                    entries.push(data.data);
                }
                else {
                    for (var i = 0; i < entries.length; i++) {
                        var entry = entries[i];
                        if (entry.id === data.data.id) {
                            entry = data.data; // replace the entry, since name might have changed
                            break;
                        }
                    }
                    getTemplateData(data.data.id); // if it is not a new template, the watcher won't trigger the getData function, so do it here
                }
            }
        });
    };

    this.saveDialog = function (event) {
        var trns = $scope.trns;

        CommentOnSaveService.showCommentOnSaveDialog(ctrl.save, event, trns.commentOnSave,
            trns.save, trns.abort, trns.comment, $scope.data.comments);
    };

    ctrl.save = function (asTemplate) {
        var dataObj = {
            budget: $scope.data
        };
        if (asTemplate) {
            return dataGen.postAsForm($scope, dataObj, "/budget/saveAsTemplate").then(function () {
                $mdToast.show(
                    $mdToast.simple()
                        .textContent($scope.trns.saveSuccess)
                        .position("bottom right")
                        .hideDelay(10000)
                );
            });
        }
        else {
            return dataGen.postAsForm({}, dataObj, "/budget/save").then(function (response) {
                if (response && response.data) {
                    if (response.data.atpId) {
                        $redirect.redirectTo(null, "/ruleuser/0/"+response.data.atpId+"/bud");
                    }
                    else {
                        BackService.back();
                    }
                }
                $mdToast.show(
                    $mdToast.simple()
                        .textContent($scope.trns.saveSuccess)
                        .position("bottom right")
                        .hideDelay(10000)
                );
            });
        }
    };

    this.deleteDialog = function (event) {
        ConfirmationService.showConfirmationDialog(ctrl.delete, event, $scope.trns.confirmDelete,
            $scope.trns.delete, $scope.trns.abort);
    };

    this.delete = function () {
        var dataObj = {
            id: $scope.data.id
        };
        dataGen.postAsForm($scope, dataObj, "/budget/delete").then(function () {
            BackService.back();
            $mdToast.show(
                $mdToast.simple()
                    .textContent($scope.trns.deleteSuccess)
                    .position("bottom right")
                    .hideDelay(10000)
            );
        });
    };

    this.exportBudgetHistory = function () {
        DownloadService.openDownloadPost('/budget/export/history', {paramName: "id", paramValue: $scope.data.id});
    };

    dataGen.getData($scope, {id: budgetId}, "/budget/view").then(function () {
        defineButtons();
    });

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.save,
                action: ctrl.saveDialog,
                type: 'validation',
                condition: isEditable,
                params: {
                    form: $scope.dialogData
                }
            },
            {
                label: $scope.trns.saveAsTemplate,
                action: function () {
                    return ctrl.save(true);
                },
                type: 'validation',
                condition: isEditable,
                params: {
                    form: $scope.dialogData
                }
            },
            {
                label: $scope.trns.newTemplate,
                action: ctrl.newTemplate,
                type: 'dialogaction',
                condition: isEditable
            },
            {
                label: $scope.trns.editTemplate,
                action: ctrl.editTemplate,
                type: 'dialogaction',
                condition: canEditTemplate
            },
            {
                label: $scope.trns.delete,
                action: ctrl.deleteDialog,
                type: 'dialogaction',
                condition: isEditable
            },
            {
                label: $scope.trns.exportBudgetHistory,
                action: ctrl.exportBudgetHistory,
                type: 'dialogaction',
                process: 'ExportBudgetHistory'
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }

    function isEditable() {
        return !$scope.data.readOnly;
    }

    function canEditTemplate() {
        return isEditable() && $scope.data.template.selected && $scope.data.template.selected.id;
    }
}
